<template>
    <div class="top-container">
        <div class="page-mode">
            <div class="title-box">
                <div class="title-name">任务中心</div>
                <div class="title-more" @click="cleanAllUnread">全部已读</div>
            </div>
            <el-scrollbar class="list-container">
                <div class="msg-container">
                    <div class="msg-item" v-for="(item, index) in msgList" :key="index"
                         @click.stop="cleanUnread(item)">
                        <div class="msg-head">
                            <div class="msg-icon">
                                <img v-if="item.code === 1" src="../../assets/image/msg-1.png" alt>
                                <img v-if="item.code === 2" src="../../assets/image/msg-2.png" alt>
                                <img v-if="item.code === 3" src="../../assets/image/msg-3.png" alt>
                                <img v-if="item.code === 4" src="../../assets/image/msg-4.png" alt>
                            </div>
                            <div class="msg-type">
                                <span v-if="item.code === 1">系统消息</span>
                                <span v-if="item.code === 2">教研消息</span>
                                <span v-if="item.code === 3">培训消息</span>
                                <span v-if="item.code === 4">活动消息</span>
                            </div>
                            <div class="msg-unread" v-if="item.isRead === 0"></div>
                        </div>
                        <div class="msg-content">{{ item.content }}</div>
                        <div class="msg-time">{{timestampToTime(item.createTime) }}</div>
                    </div>
                </div>
                <el-empty style="padding-top: 10vh;" v-if="msgList.length === 0" :image-size="160"
                          description="暂无消息" />
            </el-scrollbar>
        </div>
    </div>
</template>

<script>

import { userMessages, cleanUnread, messageCleanAllUnread } from "@/api/admin/message"
import {timestampToTime} from "@/utils/date";
import {ElMessageBox} from "element-plus";

export default {
    name: "systemCenter",
    components: {},
    data() {
        return {
            timestampToTime,
            token: this.$storage.get("token"),
            // 基础：基数数据表格数据
            msgList: [],
        };
    },
    created() {
        this.getMsgList();
    },
    activated() {},
    watch: {},
    methods: {
        getMsgList(){
            userMessages().then(res => {
                res.data.data = res.data.data.filter(item => {
                    return item.code !== 1
                })
                this.msgList = res.data.data;
            });
        },
        cleanUnread(item) {
            cleanUnread({ messageId: item.messageId }).then(res => {
                if (res.data.code === 1) {
                    this.getMsgList();
                    if (item.type === 11) {
                        // 培训任务

                    } else if (item.type === 12 || item.type === 17) {
                        // 备课任务

                    } else if (item.type === 13 || item.type === 18) {
                        // "听评课任务

                    } else if (item.type === 14 || item.type === 19) {
                        // 新课题

                    } else if (item.type === 15 || item.type === 20) {
                        // 新赛事

                    } else if(item.type === 16 || item.type === 21){
                        // 新活动

                    }
                } else {
                    this.$message.error("操作失败");
                }
            })

        },
        cleanAllUnread() {
            var _this = this;
            ElMessageBox.confirm(
              '消息是否全部已读?',
              '通知',
              {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
              }
            ).then(() => {
                messageCleanAllUnread().then(res => {
                    if (res.data.code === 1) {
                        _this.$message.success("操作成功");
                        _this.getMsgList();
                    } else {
                        _this.$message.error("操作失败");
                    }
                })
            }).catch(() => {

            })
        },
    }
};
</script>
<style scoped>
.top-container{
    width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: auto!important;
}
.page-mode{
    width: 100%;
    height: calc(100vh - 182px);
    background-color: #fff;
    border-radius: 16px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.title-box{
    display: flex;
    align-items: center;
    height: 52px;
    padding: 0 16px;
    box-sizing: border-box;
    border-bottom: 1px solid #f0f0f0;
    flex-shrink: 0;
}
.title-name{
    height: 20px;
    line-height: 20px;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    border-left: 4px solid #ff7f2e;
    padding-left: 8px;
}
.title-more{
    margin-left: auto;
    font-size: 14px;
    color: #29a8f0;
    cursor: pointer;
}
.title-more:hover{
    color: #ff7f2e;
}
.list-container{
    flex: 1;
    min-height: 0;
}
.msg-container{
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    padding: 16px;
    box-sizing: border-box;
}
.msg-item{
    width: calc(25% - 12px);
    background: #fff;
    border: 1px solid #f0f0f0;
    border-radius: 12px;
    padding: 14px 16px;
    box-sizing: border-box;
    cursor: pointer;
    transition: box-shadow .2s;
}
.msg-item:hover{
    box-shadow: 0 2px 12px rgba(13, 85, 164, .12);
}
.msg-head{
    display: flex;
    align-items: center;
}
.msg-icon{
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    img{
        width: 100%;
        height: 100%;
    }
}
.msg-type{
    margin-left: 10px;
    font-size: 14px;
    font-weight: bold;
    color: #333;
}
.msg-unread{
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #f56c6c;
    margin-left: auto;
    flex-shrink: 0;
}
.msg-content{
    margin-top: 10px;
    height: 40px;
    font-size: 14px;
    color: #666;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.msg-time{
    margin-top: 10px;
    font-size: 13px;
    color: #999;
    text-align: right;
}
</style>
